"use strict";

// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var TaskStatus_1 = require("./TaskStatus");
/*
 * [[BaseTask]] provides common utilities for task implementations.
 */
var BaseTask = /** @class */function () {
  function BaseTask(logger) {
    this.logger = logger;
    this.taskName = 'BaseTask';
    this.parentTask = null;
    this.status = TaskStatus_1.default.IDLE;
    this.run = this.baseRun.bind(this, this.run);
    this.cancel = this.baseCancel.bind(this, this.cancel);
  }
  BaseTask.prototype.cancel = function () {};
  BaseTask.prototype.name = function () {
    return this.parentTask ? this.parentTask.name() + "/" + this.taskName : this.taskName;
  };
  BaseTask.prototype.setParent = function (parentTask) {
    this.parentTask = parentTask;
  };
  BaseTask.prototype.getStatus = function () {
    return this.status;
  };
  BaseTask.prototype.logAndThrow = function (message) {
    this.logger.info(message);
    throw new Error(message);
  };
  BaseTask.prototype.baseRun = function (originalRun) {
    return __awaiter(this, void 0, void 0, function () {
      var startTime, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);
            startTime = Date.now();
            this.logger.info("running task " + this.name());
            switch (this.status) {
              case TaskStatus_1.default.RUNNING:
                this.logAndThrow(this.name() + " is already running");
              case TaskStatus_1.default.CANCELED:
                this.logAndThrow(this.name() + " was canceled before running");
              case TaskStatus_1.default.FINISHED:
                this.logAndThrow(this.name() + " was already finished");
            }
            this.status = TaskStatus_1.default.RUNNING;
            return [4 /*yield*/, originalRun.call(this)];
          case 1:
            _a.sent();
            this.logger.info(this.name() + " took " + Math.round(Date.now() - startTime) + " ms");
            return [3 /*break*/, 4];
          case 2:
            err_1 = _a.sent();
            throw err_1;
          case 3:
            if (this.status !== TaskStatus_1.default.CANCELED) {
              this.status = TaskStatus_1.default.FINISHED;
            }
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  BaseTask.prototype.baseCancel = function (originalCancel) {
    if (this.status === TaskStatus_1.default.CANCELED || this.status === TaskStatus_1.default.FINISHED) {
      return;
    }
    this.logger.info("canceling task " + this.name());
    this.status = TaskStatus_1.default.CANCELED;
    originalCancel.call(this);
  };
  return BaseTask;
}();
exports.default = BaseTask;